import { ICustomRoute } from '../../app-routing.module';
import { AppEventsListComponent } from './events-list/hero-events-list.component';
import { HeaderButtonAction } from '../../shared/page-header/header-button';
import { PrivilegeEnum } from '@whetstoneeducation/hero-common';
import { AppEventCategoryListComponent } from './event-category-list/event-category-list.component';
import { AppEventCategoryListResolver } from './event-category-list/event-category-list.resolver';
import { AuthGuard } from '../../route-guards/auth.guard';
import { AppHeroEventCreateEditComponent } from './hero-event-create-edit/hero-event-create-edit.component';
import { AppHeroEventCreateEditResolver } from './hero-event-create-edit/hero-event-create-edit.resolver';
import { AppHeroEventsListResolver } from './events-list/hero-events-list.resolver';
import { AppScheduledHeroEventViewEditResolver } from './scheduled-hero-event-view-edit/scheduled-hero-event-view-edit.resolver';
import { ScheduledHeroEventViewEditComponent } from './scheduled-hero-event-view-edit/scheduled-hero-event-view-edit.component';
import { AppHistoricalScheduledHeroEventListComponent } from './historical-scheduled-hero-event-list/historical-scheduled-hero-event-list.component';
import { AppHistoricalScheduledHeroEventListResolver } from './historical-scheduled-hero-event-list/historical-scheduled-hero-event-list.resolver';

export const AppEventsRoutes: ICustomRoute[] = [
  {
    path: 'events',
    title: 'Events',
    component: AppEventsListComponent,
    resolve: { data: AppHeroEventsListResolver },
    canActivate: [AuthGuard],
    data: {
      title: 'Events List',
      buttons: [
        {
          name: 'Create Event',
          normalizedRoute: 'event/new',
          color: 'primary',
          privilege: PrivilegeEnum.CREATE_EDIT_EVENTS
        },
        {
          name: 'Manage Event Categories',
          normalizedRoute: 'event-categories',
          color: 'primary',
          privilege: PrivilegeEnum.CREATE_EDIT_EVENTS
        }
      ]
    }
  },
  {
    path: 'event-categories',
    title: 'Events Categories',
    canActivate: [AuthGuard],
    component: AppEventCategoryListComponent,
    resolve: { data: AppEventCategoryListResolver },
    data: {
      title: 'Event Categories List',
      buttons: [
        {
          name: 'Create',
          color: 'primary',
          style: 'secondary-button',
          action: HeaderButtonAction.CREATE,
          privilege: PrivilegeEnum.CREATE_EDIT_EVENTS
        },
        {
          name: 'Back',
          style: 'outline-button',
          action: HeaderButtonAction.BACK
        }
      ]
    }
  },
  {
    path: 'event/new',
    title: 'Event',
    canActivate: [AuthGuard],
    component: AppHeroEventCreateEditComponent,
    resolve: { data: AppHeroEventCreateEditResolver },
    data: {
      title: 'Create Event',
      buttons: [
        {
          name: 'Create',
          color: 'primary',
          style: 'secondary-button',
          action: HeaderButtonAction.SAVE,
          privilege: PrivilegeEnum.CREATE_EDIT_EVENTS
        },
        {
          name: 'Back',
          style: 'outline-button',
          action: HeaderButtonAction.BACK
        }
      ]
    }
  },
  {
    path: 'event/:id',
    title: 'Event',
    canActivate: [AuthGuard],
    component: AppHeroEventCreateEditComponent,
    resolve: { data: AppHeroEventCreateEditResolver },
    data: {
      title: 'Edit Event',
      buttons: [
        {
          name: 'Update',
          color: 'primary',
          style: 'secondary-button',
          action: HeaderButtonAction.SAVE,
          privilege: PrivilegeEnum.CREATE_EDIT_EVENTS
        },
        {
          name: 'Back',
          style: 'outline-button',
          action: HeaderButtonAction.BACK
        }
      ]
    }
  },
  {
    path: 'scheduled-event/:id',
    title: 'Event',
    canActivate: [AuthGuard],
    component: ScheduledHeroEventViewEditComponent,
    resolve: { data: AppScheduledHeroEventViewEditResolver }
  },
  {
    path: 'historical-scheduled-hero-events/:id',
    title: 'Historical Events',
    canActivate: [AuthGuard],
    component: AppHistoricalScheduledHeroEventListComponent,
    resolve: { data: AppHistoricalScheduledHeroEventListResolver },
    data: {
      title: 'Past Hero Events',
      buttons: [
        {
          name: 'Back',
          style: 'outline-button',
          action: HeaderButtonAction.BACK
        }
      ]
    }
  }
];
